import type { HistogramChartXAxisProps } from '../types/histogram-props.js';

export const XAxis = (props: HistogramChartXAxisProps) => null;

XAxis['displayName'] = 'HistogramChart.XAxis';
